import React, { Suspense } from "react";

export const isAuthoringEnabled = () =>
  process.env.REACT_APP_TOUR_AUTHORING === "true";

let LazyPanel = null;
const getLazyPanel = () => {
  if (!LazyPanel && isAuthoringEnabled()) {
    LazyPanel = React.lazy(() => import("./TourAuthoringPanel"));
  }
  return LazyPanel;
};

const TourAuthoringWrapper = (props) => {
  const Component = getLazyPanel();
  if (!Component) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <Component {...props} />
    </Suspense>
  );
};

export default TourAuthoringWrapper;
